import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import {
  jerboaClientNetworkLoadContextSchema,
  jerboaClientNetworkLoadDetailResponseSchema,
  jerboaClientNetworkLoadStatusSchema,
  jerboaClientNetworkLoadsListResponseSchema,
  networkLoadAnalysisResponseSchema,
} from "./schemas";

export const fetchJerboaClientNetworkLoadsQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa-client-network-loads", "list"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-client-network-loads",
  paramsSchema: z.object({
    afterCursor: z.string().nullable().optional().default(null),
    pageSize: z.number().max(50).optional().default(20),
    status: jerboaClientNetworkLoadStatusSchema.optional(),
    context: jerboaClientNetworkLoadContextSchema.optional(),
    projectId: z.string().optional(),
  }),
  responseSchema: jerboaClientNetworkLoadsListResponseSchema,
}).withPagination({
  getNextPageParam(lastPage) {
    return lastPage.pageInfo.hasNextPage ? lastPage.pageInfo.endCursor : undefined;
  },
  mapPaginationParamsToQueryParams({ pageParam }) {
    return {
      ...(pageParam ? { afterCursor: pageParam } : {}),
      pageSize: 20,
    };
  },
});

export const getJerboaClientNetworkLoadQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa-client-network-loads", "detail"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-client-network-loads/:id",
  responseSchema: jerboaClientNetworkLoadDetailResponseSchema,
});

export const fetchJerboaClientNetworkLoadAnalysisQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "jerboa-client-network-loads", "analysis"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/jerboa-client-network-loads/analysis",
  paramsSchema: z.object({
    days: z.number().min(1).max(90).default(7),
  }),
  responseSchema: networkLoadAnalysisResponseSchema,
});
